// extracted by mini-css-extract-plugin
module.exports = {"loadingCards":"_1e101zp-_EfOLE0QMw0sfG","loadingCard":"U0KonZ36FylTD9OrubAEJ","upperSection":"_1VElcLWfMANohj96XLpcvU","lowerSection":"_2xhCX3pD5etu2_h4p24kQY"};